// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"401":"aa02e442","500":"2e85cd94","688":"7d14c725","992":"01f0b048"}[chunkId] + ".chunk.css";
};